import { graphEndpoints, graphScopes } from "./authConfig";

async function getGraphToken(msalInstance, account) {
  const request = { ...graphScopes, account };
  try {
    const result = await msalInstance.acquireTokenSilent(request);
    return result.accessToken;
  } catch {
    const result = await msalInstance.acquireTokenPopup(request);
    return result.accessToken;
  }
}

export async function fetchUserProfile(msalInstance, account) {
  const token = await getGraphToken(msalInstance, account);
  const res = await fetch(graphEndpoints.meExtended, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Graph /me failed: ${res.status}`);
  const me = await res.json();

  // businessPhone: desk/office phone from Entra (visible in Outlook/Teams)
  const businessPhone = (me.businessPhones && me.businessPhones[0]) || "";

  // mobile: set in on-prem AD via ADUC → Attribute Editor → extensionAttribute1
  // Synced to Entra via AD Connect. NOT shown in Outlook/Teams.
  // Empty string for users who haven't opted in.
  const mobile = me.onPremisesExtensionAttributes?.extensionAttribute1 || "";

  const addressParts = [me.officeLocation, me.city, me.country].filter(Boolean);

  const email = me.mail || me.userPrincipalName || "";
  const domain = email.split("@")[1] || "";
  const WEBSITE_MAP = {
    "athens.ddb.com":  "https://www.ddb.gr",
    "ddb.com":         "https://www.ddb.gr",
    "briefme.gr":      "https://www.briefme.gr",
    "omikron.gr":      "https://www.omikrongroup.gr",
    "omikrongroup.gr": "https://www.omikrongroup.gr",
    "ignota.io":       "https://www.ignota.io",
    "oktasoft.gr":     "https://www.oktasoft.gr",
    "lama.gr":         "https://www.lamaddb.com",
  };
  const website = WEBSITE_MAP[domain] || "";

  return {
    firstName:     me.givenName    || me.displayName?.split(" ")[0] || "",
    lastName:      me.surname      || me.displayName?.split(" ").slice(1).join(" ") || "",
    title:         me.jobTitle     || "",
    company:       me.companyName  || "",
    department:    me.department   || "",
    businessPhone,
    mobile,
    email,
    website,
    address:       addressParts.join(", "),
  };
}

export async function fetchUserPhoto(msalInstance, account) {
  const token = await getGraphToken(msalInstance, account);
  try {
    const res = await fetch(graphEndpoints.photo, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return null;
    const blob = await res.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  } catch {
    return null;
  }
}
